import React from 'react';
import {useSelector} from 'react-redux';

import {Panel} from 'primereact/panel';

import ContentButton from '~/frontend/src/components/base/shared/ContentButton';

import {__} from '~/shared/src/utilities/messageCatalog';
import {formatTimestamp} from '~/shared/src/utilities/valueFormaters';

import {StoreState} from '~/frontend/src/store';


type Props = {

    /**
     * The CSS class name(s) to add to the component.
     */
    className? : string;
};

type AllProps = Props;


/**
 * info
 * @return {JSX.Element}
 * @constructor
 */
const InfoButton = ( props : AllProps ) => {
    const {
              className
          }    = props,
          user = useSelector( ( state : StoreState ) => state.session?.user );

    return <ContentButton
        id="page-menu-info-button"

        horizontalContentAlign="left"
        verticalContentAlign="bottom"
        rounded={true}
        text={true}
        icon="fas fa-info-circle"
        className={`yn-infomenu-button yn-blue ${className}`}
        buttonClassName="yn-infomenu-button"
        contentClassName="yn-contentbutton-overlay-content-page-menu"

        content={
            <Panel
                style={{ width: '25rem' }}
                className="p-0"
                pt={{
                    content: {
                        style: {
                            border : 'none'
                        }
                    }
                }}
            >
                <div className="yn-secondary" style={{ fontSize: '10px', marginBottom: '1rem', textAlign: 'center', width: '100%' }}>
                    powered by<br/>
                    <a href="https://yoonite.net" target="_blank">
                        <span className="fsz-logo"/>
                    </a>
                </div>
                <label
                    key="header"

                    className="yn-menu-title-label"
                >
                    {__( 'YN.base.info.title' )}
                </label>

                <label
                    className="yn-menu-subtitle-label block"
                >
                    {__( 'YN.base.info.common.title' )}
                </label>

                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Base-URL:</span> {BASE_URL}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Socket-URL:</span> {SOCKET_URL}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Version:</span> {APP_VERSION}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Created:</span> {formatTimestamp( APP_TIME )}<br/>

                <label
                    className="yn-menu-subtitle-label block mt-3"
                >
                    {__( 'YN.base.info.environment.title' )}
                </label>

                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>User:</span> {user ? user.userId : ''}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Application:</span> {global.config.application.name}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Stage:</span> {global.config.application.stage}<br/>
                <span className="yn-bold" style={{ display: 'inline-block', width: '7rem' }}>Database:</span> {global.config.database.name}<br/>

                <label
                    className="yn-menu-subtitle-label block mt-3"
                >
                    {__( 'YN.base.info.application.title' )}
                </label>

                <span className="yn-bold">Application:</span> {user ? user.application?.title : ''}

            </Panel>
        }
    />;
}

export default InfoButton;
